const appVersion = (ctx, next) => {
  const { locals } = ctx;

  if (process.browser) {
    // Keep the version the server rendered. The client bundle only knows its
    // build-time GIT_VERSION, which in local dev doesn't change between
    // commits — re-rendering the asset links with it after a client-side
    // navigation made the browser serve a stale cached app.css.
    const link = document.querySelector('link[href^="/css/app.css?v="]');
    const serverVersion = link && new URL(link.href).searchParams.get("v");
    if (serverVersion) {
      locals.appVersion = serverVersion;
      return next();
    }
  }

  if (process.env.GIT_VERSION) {
    locals.appVersion = process.env.GIT_VERSION;
    return next();
  }

  if (!process.browser && !process.env.GIT_VERSION) {
    // Local dev: no GIT_VERSION is baked in. Derive the cache-busting version
    // from the newest built client asset (JS bundle or the copied Tailwind
    // CSS) so the `?v=` query bumps on every rebuild — the browser then
    // fetches fresh files on a normal reload, removing the need for devtools
    // "clear cache on reload".
    if (process.env.NODE_ENV === "local") {
      try {
        const fs = require("node:fs");
        const path = require("node:path");
        const assets = [
          "dist/client/js/main.bundle.js",
          "dist/client/css/app.css",
        ];
        const newest = Math.max(
          ...assets.map((asset) => {
            try {
              return fs.statSync(path.resolve(asset)).mtimeMs;
            } catch {
              return 0;
            }
          })
        );
        if (newest > 0) {
          locals.appVersion = String(Math.trunc(newest));
          return next();
        }
      } catch {
        // fall through to the git-describe default
      }
    }

    const child_process = require("node:child_process");
    locals.appVersion = child_process
      .execSync("git describe --always", { encoding: "utf8" })
      .trim();
  }

  return next();
};

export default appVersion;
